export const PAUSED_OAUTH_SESSION_KEY = 'skyspace-oauth-session-paused-v1';

export function automaticSessionDid<T extends string>(
  storedDids: T[],
  pausedDid: string | null,
): T | undefined {
  return pausedDid ? undefined : storedDids[0];
}

export function rememberedSessionDid<T extends string>(
  storedDids: T[],
  identityDid: string,
): T | undefined {
  return storedDids.find(did => did === identityDid);
}
